export const secondsToHHMMSS = (seconds: number) => {
    // Calculate hours, minutes, and seconds
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    // Format hours, minutes, and seconds as two digits
    const formattedHrs = hrs.toString().padStart(2, '0');
    const formattedMins = mins.toString().padStart(2, '0');
    const formattedSecs = secs.toString().padStart(2, '0');

    const timestamp = `${formattedHrs}:${formattedMins}:${formattedSecs}`

    // Return formatted string
    return timestamp;
}

export const HHMMSSToSeconds = (timestamp: string) => {
    const parts = timestamp.split(':').map(Number); // Split the string by ':' and convert each part to a number
    if (parts.some(isNaN)) {
        return 0;
    }

    let seconds = 0;

    // If the format is HH:MM:SS
    if (parts.length === 3) {
        const [hours, minutes, secs] = parts;
        seconds = hours * 3600 + minutes * 60 + secs;
    }
    // If the format is MM:SS
    else if (parts.length === 2) {
        const [minutes, secs] = parts;
        seconds = minutes * 60 + secs;
    } else {
        return 0;
    }

    return seconds;
}